// import React, { useState } from 'react';
// import './CareerDb.css'; // Import the CSS file

// const CareerDb = () => {
//   const [formData, setFormData] = useState({
//     companyName: '',
//     jobTitle: '',
//     jobDescription: '',
//     location: '',
//     salary: '',
//     applicationLink: '',
//     deadline: '', 
//   });

//   const [linkError, setLinkError] = useState('');
//   const [submitMessage, setSubmitMessage] = useState('');
//   const maxWords = 150;

//   const handleChange = (e) => {
//     const { name, value } = e.target;

//     // If it's the job description, restrict word count
//     if (name === 'jobDescription') {
//       const words = value.split(/\s+/).filter((word) => word.length > 0);
//       if (words.length <= maxWords) {
//         setFormData({ ...formData, [name]: value });
//       }
//     } else {
//       setFormData({ ...formData, [name]: value });
//     }
//   };

// //   const validateLink = () => {
// //   // eslint-disable-next-line no-useless-escape
// // const urlRegex = /^(https?:\/\/)?([a-zA-Z0-9.-]+)\.([a-zA-Z]{2,})([\/\w.-]*)*\/?$/;
// //     if (!urlRegex.test(formData.applicationLink)) {
// //       setLinkError('Please enter a valid URL.');
// //     } else {
// //       setLinkError('');
// //     }
// //   };
  
  
//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setSubmitMessage(""); // Reset message
  
//     console.log("📤 Sending Job Data:", formData); // ✅ Log job data before submission
  
//     try {
//       const response = await fetch('http://localhost:9000/api/jobs', {  
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify(formData),
//       });
  
//       const result = await response.json();
//       console.log("📥 API Response:", result); // ✅ Log response from backend
  
//       if (response.ok) {
//         setSubmitMessage('✅ Job posted successfully!');
//         setFormData({
//           companyName: '',
//           jobTitle: '',
//           jobDescription: '',
//           location: '',
//           salary: '',
//           applicationLink: '',
//           deadline: '',
//         });
//       } else {
//         setSubmitMessage(`❌ ${result.message || 'Failed to submit data'}`);
//       }
//     } catch (error) {
//       console.error("❌ Error submitting form:", error);
//       setSubmitMessage("❌ Error connecting to the server");
//     }
//   };






  

//   const wordCount = formData.jobDescription.split(/\s+/).filter((word) => word.length > 0).length;

//   return (
//     <div className="career-db">
//       <h1>Career Details</h1>
//       <form onSubmit={handleSubmit}>
//         {/* Company Name */}
//         <div className="form-group">
//           <label htmlFor="companyName">Company Name:</label>
//           <input
//             type="text"
//             id="companyName"
//             name="companyName"
//             value={formData.companyName}
//             onChange={handleChange}
//             required
//           />
//         </div>

//         {/* Job Title */}
//         <div className="form-group">
//           <label htmlFor="jobTitle">Job Title:</label>
//           <input
//             type="text"
//             id="jobTitle"
//             name="jobTitle"
//             value={formData.jobTitle}
//             onChange={handleChange}
//             required
//           />
//         </div>

//         {/* Job Description */}
//         <div className="form-group">
//           <label htmlFor="jobDescription">Job Description (Max 30 Words):</label>
//           <textarea
//             id="jobDescription"
//             name="jobDescription"
//             rows="5"
//             value={formData.jobDescription}
//             onChange={handleChange}
//             placeholder="Enter job description here..."
//             required
//           ></textarea>
//           <small>
//             {wordCount}/{maxWords} words
//           </small>
//         </div>

//         {/* Location */}
//         <div className="form-group">
//           <label htmlFor="location">Location:</label>
//           <select
//             id="location"
//             name="location"
//             value={formData.location}
//             onChange={handleChange}
//             required
//           >
//             <option value="">Select a City</option>
//             <option>Agartala</option>
//             <option>Aizawl</option>
//             <option>Amaravati</option>
//             <option>Bengaluru</option>
//             <option>Bhopal</option>
//             <option>Bhubaneswar</option>
//             <option>Chandigarh</option>
//             <option>Chennai</option>
//             <option>Dehradun</option>
//             <option>Gandhinagar</option>
//             <option>Gangtok</option>
//             <option>Greater Noida</option>
//             <option>Gurugram</option>
//             <option>Guwahati</option>
//             <option>Hyderabad</option>
//             <option>Imphal</option>
//             <option>Itanagar</option>
//             <option>Jaipur</option>
//             <option>Kohima</option>
//             <option>Kolkata</option>
//             <option>Lucknow</option>
//             <option>Mumbai</option>
//             <option>New Delhi</option>
//             <option>Noida</option>
//             <option>Panaji</option>
//             <option>Patna</option>
//             <option>Pune</option>
//             <option>Raipur</option>
//             <option>Ranchi</option>
//             <option>Shillong</option>
//             <option>Shimla</option>
//             <option>Srinagar</option>
//             <option>Thiruvananthapuram</option>
           
//           </select>
//         </div>

//         {/* Salary */}
//         <div className="form-group">
//           <label htmlFor="salary">Salary:</label>
//           <select
//             id="salary"
//             name="salary"
//             value={formData.salary}
//             onChange={handleChange}
//             required
//           >
//             <option value="">Select a Salary Range</option>
//             <option>1-5 LPA</option>
//             <option>5-10 LPA</option>
//             <option>10-15 LPA</option>
//             <option>15-20 LPA</option>
//             <option>20-25 LPA</option>
//             <option>25-30 LPA</option>
//             <option>30-35 LPA</option>
//             <option>35-40 LPA</option>
//             <option>40-45 LPA</option>
//             <option>45-50 LPA</option>
           
//           </select>
//         </div>

//         {/* Application Link */}
//         <div className="form-group">
//           <label htmlFor="applicationLink">Application Link:</label>
//           <textarea
//             id="applicationLink"
//             name="applicationLink"
//             rows="2"
//             value={formData.applicationLink}
//             onChange={(e) => {
//               handleChange(e);
//               // validateLink();
//             }}
//             placeholder="Enter the application URL..."
//             required
//           ></textarea>
//           {linkError && <small className="error">{linkError}</small>}
//         </div>
        
//         {/* Deadline */}
// <div className="form-group">
//   <label htmlFor="deadline">Deadline:</label>
//   <input
//     type="date"
//     id="deadline"
//     name="deadline"
//     value={formData.deadline || ''}
//     onChange={handleChange}
//     required
//   />
// </div>




//         {/* Submit Button */}
//         <button type="submit" className="submit-button" disabled={!!linkError}>
//           Post
//         </button>
//         {submitMessage && <p>{submitMessage}</p>}
//       </form>
//     </div>
//   );
// };

// export default CareerDb;






import React, { useState } from "react";
import { useNavigate } from "react-router-dom"; // ✅ Import for redirection
import "./CareerDb.css"; // Import the CSS file

const CareerDb = () => {
  const navigate = useNavigate(); // ✅ Hook for redirection

  const [formData, setFormData] = useState({
    companyName: "",
    jobTitle: "",
    jobDescription: "",
    location: "",
    salary: "",
    applicationLink: "",
    deadline: "",
  });

  const [linkError, setLinkError] = useState("");
  const [submitMessage, setSubmitMessage] = useState("");
  const maxWords = 150;

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "jobDescription") {
      const words = value.split(/\s+/).filter((word) => word.length > 0);
      if (words.length <= maxWords) {
        setFormData({ ...formData, [name]: value });
      }
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitMessage("");

    console.log("📤 Sending Job Data:", formData);

    try {
      const response = await fetch("https://career-service-hd0s.onrender.com/api/jobs", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      const result = await response.json();
      console.log("📥 API Response:", result);

      if (response.ok) {
        setSubmitMessage("✅ Job posted successfully!");

        // ✅ Reset form fields
        setFormData({
          companyName: "",
          jobTitle: "",
          jobDescription: "",
          location: "",
          salary: "",
          applicationLink: "",
          deadline: "",
        });

        // ✅ Redirect to Career Dashboard after 1.5 seconds
        setTimeout(() => {
          navigate("/pages/career-dashboard");
        }, 1500);
      } else {
        setSubmitMessage(`❌ ${result.message || "Failed to submit data"}`);
      }
    } catch (error) {
      console.error("❌ Error submitting form:", error);
      setSubmitMessage("❌ Error connecting to the server");
    }
  };

  const wordCount = formData.jobDescription
    .split(/\s+/)
    .filter((word) => word.length > 0).length;

  return (
    <div className="career-db">
      <h1>Career Details</h1>
      <form onSubmit={handleSubmit}>
        {/* Company Name */}
        <div className="form-group">
          <label htmlFor="companyName">Company Name:</label>
          <input
            type="text"
            id="companyName"
            name="companyName"
            value={formData.companyName}
            onChange={handleChange}
            required
          />
        </div>

        {/* Job Title */}
        <div className="form-group">
          <label htmlFor="jobTitle">Job Title:</label>
          <input
            type="text"
            id="jobTitle"
            name="jobTitle"
            value={formData.jobTitle}
            onChange={handleChange}
            required
          />
        </div>

        {/* Job Description */}
        <div className="form-group">
          <label htmlFor="jobDescription">Job Description (Max 150 Words):</label>
          <textarea
            id="jobDescription"
            name="jobDescription"
            rows="5"
            value={formData.jobDescription}
            onChange={handleChange}
            placeholder="Enter job description here..."
            required
          ></textarea>
          <small>
            {wordCount}/{maxWords} words
          </small>
        </div>

        {/* Location */}
        <div className="form-group">
          <label htmlFor="location">Location:</label>
          <select id="location" name="location" value={formData.location} onChange={handleChange} required>
            <option value="">Select a City</option>
            <option>Agartala</option>
            <option>Aizawl</option>
             <option>Amaravati</option>
             <option>Bengaluru</option>
             <option>Bhopal</option>
             <option>Bhubaneswar</option>
             <option>Chandigarh</option>
                          <option>Chennai</option>
            <option>Dehradun</option>
             <option>Gandhinagar</option>
             <option>Gangtok</option>
             <option>Greater Noida</option>
             <option>Gurugram</option>
             <option>Guwahati</option>
             <option>Hyderabad</option>
            <option>Imphal</option>
            <option>Itanagar</option>
             <option>Jaipur</option>
             <option>Kohima</option>
            <option>Kolkata</option>
             <option>Lucknow</option>
             <option>Mumbai</option>
             <option>New Delhi</option>
             <option>Noida</option>
             <option>Panaji</option>
             <option>Patna</option>
             <option>Pune</option>
            <option>Raipur</option>
             <option>Ranchi</option>
           <option>Shillong</option>
            <option>Shimla</option>
            <option>Srinagar</option>
             <option>Thiruvananthapuram</option>
          </select>
        </div>

        {/* Salary */}
        <div className="form-group">
          <label htmlFor="salary">Salary:</label>
          <select id="salary" name="salary" value={formData.salary} onChange={handleChange} required>
            <option value="">Select a Salary Range</option>
            <option>1-5 LPA</option>
            <option>5-10 LPA</option>
            <option>10-15 LPA</option>
            <option>15-20 LPA</option>
            <option>20-25 LPA</option>
            <option>25-30 LPA</option>
            <option>30-35 LPA</option>
            <option>35-40 LPA</option>
          </select>
        </div>

        {/* Application Link */}
        <div className="form-group">
          <label htmlFor="applicationLink">Application Link:</label>
          <textarea
            id="applicationLink"
            name="applicationLink"
            rows="2"
            value={formData.applicationLink}
            onChange={handleChange}
            placeholder="Enter the application URL..."
            required
          ></textarea>
          {linkError && <small className="error">{linkError}</small>}
        </div>

        {/* Deadline */}
        <div className="form-group">
          <label htmlFor="deadline">Deadline:</label>
          <input type="date" id="deadline" name="deadline" value={formData.deadline || ""} onChange={handleChange} required />
        </div>

        {/* Submit Button */}
        <button type="submit" className="submit-button" disabled={!!linkError}>
          Post
        </button>
        {submitMessage && <p>{submitMessage}</p>}
      </form>
    </div>
  );
};

export default CareerDb;
